export function onOffFilter(value: boolean | null): string {
  return value ? 'On' : 'Off';
}
